import { type HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'green' | 'blue' | 'yellow' | 'red' | 'purple'
}

/** Copied from ../../agent-house/src/components/ui/Badge.tsx for visual parity. */
export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        {
          'bg-slate-700 text-slate-300': variant === 'default',
          'bg-brand-900/60 text-brand-300 border border-brand-800': variant === 'green',
          'bg-blue-900/60 text-blue-300 border border-blue-800': variant === 'blue',
          'bg-yellow-900/60 text-yellow-300 border border-yellow-800': variant === 'yellow',
          'bg-red-900/60 text-red-300 border border-red-800': variant === 'red',
          'bg-purple-900/60 text-purple-300 border border-purple-800': variant === 'purple',
        },
        className,
      )}
      {...props}
    />
  )
}
